import Footerimg from "../assets/Footer.webp";
import Btn from "../resuable-components/Button";
import { trackSignupEvent } from '../../../utlis/useAnalytics';
export default function Cta() {

  const btnClick = () => {
    trackSignupEvent( {
      page: 'Global Collection',
      section: 'End Cta SignUp',
    });
  };

  return (
    <div className="flex flex-col md:pl-[10%] md:pr-[10%] lg:flex-row items-center justify-center gap-10 px-4 lg:px-[10%]  mt-[140px]">
      <div className="text-center lg:text-left max-w-lg">
        <p className="font-bold text-[#1A202C] text-2xl lg:text-3xl font-inter mb-4">
          Save more, Earn more—start receiving payments at just 0.75% fees!
        </p>
        <Btn onClick={btnClick} />
      </div>
      <div className="max-w-[500px] w-full flex justify-center">
        <img
          src={Footerimg}
          alt="Demo Illustration"
          loading="lazy"
          className="hover:scale-[105%] hover:cursor-pointer transition-transform duration-300 mb-[-20px] w-full object-contain"
        />
      </div>
    </div>
  );
}
